import { render, staticRenderFns } from "./Taxi.vue?vue&type=template&id=781ed6fe&scoped=true&"
import script from "./Taxi.vue?vue&type=script&lang=js&"
export * from "./Taxi.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=781ed6fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ed6fe",
  null
  
)

export default component.exports